import { Reducer } from 'redux';

interface CounterState {
  currentSection: string;
}

const initialState: CounterState = {
  currentSection: 'broker',
};

const currentSectionUpdateReducer: Reducer<CounterState> = (state = initialState, action) => {
  switch (action.type) {
    case 'PRICING':
      return {
        ...state,
        currentSection: 'pricing',
      };
    case 'BROKER':
      return {
        ...state,
        currentSection: 'broker',
      };
    default:
      return state;
  }
};

export default currentSectionUpdateReducer;
